import { memo } from "react";
import { Typography, Box } from "@mui/material";
import OwnerForm from "../../components/forms/OwnerForm.js";
import useCreateStyles from "../../components/styles/Create.js"

const CreateOwner = () => {
    const classes = useCreateStyles();
    return (
        <>
            <Box className={classes.outerBox}>
                <Box container flexDirection="column" className={classes.innerBox}>
                    <Typography variant="h4" sx={{ margin: "1rem" }}>
                        Προσθήκη εκτροφής
                    </Typography>
                    <OwnerForm
                        isCreate={true}          
                        fetchedOwner={null}      
                    />
                </Box>
            </Box>
        </>
    )
}

export default memo(CreateOwner)